import type DxfArrayScanner from '../../DxfArrayScanner';
import type { ScannerGroup } from '../../DxfArrayScanner';
import { generateIntegers } from '../../../utils';
import { CommonEntitySnippets } from '../shared';
import {
  createParser,
  DXFParserSnippet,
  Identity,
  PointParser
} from '../../shared/parserGenerator';
import type { ThreeDFaceEntity } from './types';

const DefaultThreeDFaceEntity = {
  vertices: [],
  invisibleEdgeFlags: 0,
};

const ThreeDFaceEntityParserSnippets: DXFParserSnippet[] = [
  {
    code: 70,
    name: 'invisibleEdgeFlags',
    parser: Identity,
  },
  {
    code: Array.from(generateIntegers(10, 14)),
    name: 'vertices',
    isMultiple: true,
    parser: PointParser,
  },
  {
    code: 100,
    name: 'subclassMarker',
    parser: Identity,
  },
  ...CommonEntitySnippets,
];

export default class ThreeDFaceEntityParser {
    static ForEntityName = '3DFACE';

    private parser = createParser(
      ThreeDFaceEntityParserSnippets,
      DefaultThreeDFaceEntity,
    );

    parseEntity(scanner: DxfArrayScanner, curr: ScannerGroup) {
      const entity = {} as any;
      this.parser(curr, scanner, entity);
      return entity as ThreeDFaceEntity;
    }
}
